module.exports = __webpack_public_path__ + "img/bg_pb.0766e912.jpg";